import { PageLayout } from '@/global/components';
import { Breadcrumbs } from '@/lib/Breadcrumbs';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { CreateCampaignCard, HomeAudienceSection, HomeContentSection, HomeDataSourceSection, HomeDestinationsSection, HomeIllustrationCard } from './parts';
import { PerformanceAudiencePage } from '@/features/performanceAudience';

export const HomePage: FC = () => {
  return (
    <PageLayout className='gap-12 @container/page'>
      <header className='grid grid-cols-1 w-full'>
        <Breadcrumbs items={[]} className='bg-primary-background' />
      </header>
      <div className='grid grid-cols-1 gap-5 lg:grid-cols-12 lg:gap-12'>
        <HomeContentSection className='lg:col-span-7 xl:col-span-6' />
        <div className='flex flex-col lg:col-span-5 xl:col-span-6'>
          <HomeIllustrationCard />
          <CreateCampaignCard />
        </div>
      </div>
      <div className='w-full grid grid-cols-1'>
        <PerformanceAudiencePage />
      </div>
      <div
        className={twMerge(
          'grid grid-cols-[repeat(2,minmax(15rem,1fr))] gap-2.5',
          '@5xl/page:grid-cols-[minmax(10rem,25%)_minmax(30rem,1fr)_minmax(12rem,25%)]'
        )}
      >
        <HomeDataSourceSection />
        <HomeAudienceSection />
        <HomeDestinationsSection />
      </div>
    </PageLayout>
  );
};
